import api from '@edu-fe/api'

export default {
  name: 'gift',
  senderInfo (id) {
    return api.create(`/course/gift/info?id=${id}`)
  },
  receive (id) {
    return api.create(`/course/gift/receive?token=${id}`)
  }
}
